import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import NothingHere from '../../custom-components/NothingHere';
import { useNavigatorStore } from '../../zustand/useNavigatorStore';
import { InstitutionsResults } from '../InstitutionsResults';
import {
  hasNavigatorQuery,
  navigatorInstitutionsConditions,
  navigatorInstitutionsUnsupported,
  parseNavigatorQuery,
} from './navigator-query';
import './NavigatorList.scss';

/**
 * The Navigator's Institutions view: the institutions the panel's query (?q=) yields, as the
 * Institutions directory lists them. The people filters do not apply here: an institution is
 * listed whether or not it has matching people. Nothing is searched until the panel's Search
 * puts a query in the URL.
 */
export function NavigatorInstitutions() {
  const location = useLocation();
  const setIsLoadingList = useNavigatorStore((state) => state.setIsLoadingList);
  // The panel's Search button spins while the list loads; not once this view is gone.
  useEffect(() => () => setIsLoadingList(false), [setIsLoadingList]);
  const q = new URLSearchParams(location.search).get('q') ?? '';
  const query = useMemo(() => parseNavigatorQuery(location.search), [q]);
  const conditions = useMemo(() => navigatorInstitutionsConditions(query), [query]);
  const unsupported = useMemo(() => navigatorInstitutionsUnsupported(query), [query]);

  if (!hasNavigatorQuery(location.search)) {
    return (
      <div className="navigator-list">
        <NothingHere text="Set filters in the panel and search to list institutions." />
      </div>
    );
  }

  return (
    <div className="navigator-list">
      {unsupported.length > 0 && (
        <div className="navigator-list__note">
          Not applied to institutions yet: {unsupported.join(', ')}.
        </div>
      )}
      <InstitutionsResults
        conditions={conditions}
        searchKey={q}
        onLoadingChange={setIsLoadingList}
        stickyHeader
      />
    </div>
  );
}
